export const checkValidEmail = (email: string) => {
  const pattern = new RegExp('^[a-zA-Z0-9._-]+@[a-zA-Z0-9-]{2,}[.][a-zA-Z]{2,4}$')
  return pattern.test(email)
}
